import { BaseRenderNode2D } from "../../NodeRender2D/BaseRenderNode2D";
import { Color } from "../../maths/Color";
import { SpineAdapter } from "../SpineAdapter";
import { SpineShaderInit } from "../material/SpineShaderInit";
export class SpineNormalRender {
    constructor() {
        this._skinIndex = 0;
    }
    getSpineColor() {
        return this._spineColor;
    }
    destroy() {
        this._renderer.destroy();
        this._renderer = null;
        this._owner._renderElements.length = 0;
    }
    initBake(obj) {
    }
    init(skeleton, templet, renderNode, state) {
        this._renderer = SpineAdapter.createNormalRender(templet);
        this._skeleton = skeleton;
        this._owner = renderNode;
        let scolor = skeleton.color;
        this._spineColor = new Color(scolor.r, scolor.g, scolor.b, scolor.a);
        let color = renderNode._spriteShaderData.getColor(BaseRenderNode2D.BASERENDER2DCOLOR) || new Color();
        color.setValue(scolor.r, scolor.g, scolor.b, scolor.a);
        if (renderNode._renderAlpha !== undefined) {
            color.a *= renderNode._renderAlpha;
        }
        else
            color.a *= renderNode.owner.alpha;
        renderNode._spriteShaderData.setColor(BaseRenderNode2D.BASERENDER2DCOLOR, color);
        renderNode._spriteShaderData.removeDefine(SpineShaderInit.SPINE_FAST);
        renderNode._spriteShaderData.removeDefine(SpineShaderInit.SPINE_RB);
        renderNode._spriteShaderData.addDefine(SpineShaderInit.SPINE_COLOR2);
    }
    play(animationName) {
    }
    setSkinIndex(index) {
        this._skinIndex = index;
    }
    changeSkeleton(skeleton) {
        this._skeleton = skeleton;
        skeleton.showSkinByIndex(this._skinIndex);
        this._skeleton.setSlotsToSetupPose();
    }
    render(time) {
        this._owner.clear();
        this._renderer.draw(this._skeleton, this._owner, -1, -1);
    }
}
